module.exports = __webpack_public_path__ + "static/media/choithramsSimplyOrganicBrand.280d6468.jpg";